"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Languages = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_i18next_1 = require("react-i18next");
require("./languages.scss");
var i18n_1 = require("../../lang/i18n");
exports.Languages = react_1.default.memo(function (_a) {
    var className = _a.className;
    var _b = (0, react_1.useState)(false), isPopupOpened = _b[0], setIsPopOpened = _b[1];
    var _c = (0, react_i18next_1.useTranslation)(), i18n = _c.i18n, t = _c.t;
    var cn = classnames_1.default;
    var selectedLanguage = i18n.language;
    var languages = i18n_1.supportedLngs.filter(function (lng) { return lng !== selectedLanguage; });
    var onChangeLanguage = function (lng) {
        i18n.changeLanguage(lng);
        location.reload();
    };
    var togglePopup = function () { return setIsPopOpened(function (prev) { return !prev; }); };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: cn("languages-block", { active: isPopupOpened }, className), onClick: togglePopup }, { children: [(0, jsx_runtime_1.jsx)("span", { children: t(selectedLanguage) }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "languages" }, { children: isPopupOpened &&
                    languages.map(function (language) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: cn({ language: isPopupOpened }), onClick: function () { return onChangeLanguage(language); } }, { children: t(language) }), language)); }) }))] })));
});
